import {
  AreasForm,
  AttachmentsForm,
  ContractDetailsForm,
  ReviewRequestForm,
  VisitDetailsForm,
  UsersTableForm,
} from "@/pages/requests/components";
import { compact } from "lodash";

export const StepperConfig = compact([
  {
    label: "Contract Details",
    component: ContractDetailsForm,
  },
  {
    label: "Visit Details",
    component: VisitDetailsForm,
  },
  {
    label: "Add Personnel",
    component: UsersTableForm,
  },
  {
    label: "Contract Locations",
    component: AreasForm,
  },
  {
    label: "Attachments",
    component: AttachmentsForm,
  },
  {
    label: "Review Request",
    component: ReviewRequestForm,
  },
]);
